// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_y43","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_YM2 StatelessWorkCardsUpsellModal-styles-cls1_y43"};